/**
 * Estilos para o componente Modal.
 *
 * Este módulo contém os componentes estilizados utilizados para renderizar
 * o modal e seu conteúdo, criando uma sobreposição na tela.
 *
 * @module Modal.Styles
 */

import styled from '@emotion/styled';

/**
 * Componente estilizado para o container do modal.
 *
 * Define o estilo para o fundo do modal com:
 * - Posição fixa que cobre toda a tela
 * - Fundo semi-transparente (preto com 50% de opacidade)
 * - Layout flexível centralizado horizontal e verticalmente
 *
 * Este componente cria o efeito de sobreposição escura que cobre toda a página
 * quando o modal está aberto.
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

/**
 * Componente estilizado para o conteúdo do modal.
 *
 * Define o estilo para a caixa de conteúdo do modal com:
 * - Largura fixa de 500px (também definida como largura mínima)
 * - Fundo branco
 * - Padding interno
 * - Cantos arredondados (8px)
 *
 * Este componente contém o conteúdo real do modal e é renderizado
 * centralizado dentro do Container.
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Content = styled.div`
  width: 500px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-width: 500px;
`;
